import {useAiChatSeason} from '@AiChat/hooks/useAiChatSeason';
import {AI_CHAT_SHORT_VIEWPORT_MAX_HEIGHT} from '@AiChat/hooks/useAiChatSeasonClassName.types';
import {AiChatSeason} from '@AiChat/lib/ai-chat-season-library.types';
import {assertNever} from '@Utils/assert-never.util';
import {useIsViewportHeightAtMost} from '@Hooks/useIsSmallerThanBreakpoint';
import seasonStyles from '@AiChat/ai-chat-season.module.scss';

export function useAiChatSeasonClassName(): string {
  const season = useAiChatSeason();
  const isShortViewport = useIsViewportHeightAtMost(AI_CHAT_SHORT_VIEWPORT_MAX_HEIGHT);

  const getSeasonVariablesClassName = (activeSeason: AiChatSeason): string => {
    switch (activeSeason) {
      case AiChatSeason.HALLOWEEN:
        return seasonStyles.halloween;
      case AiChatSeason.CHRISTMAS:
        return getChristmasVariablesClassName();
      default:
        return assertNever(activeSeason);
    }
  };

  const getChristmasVariablesClassName = (): string => {
    if (isShortViewport) {
      return `${seasonStyles.christmas} ${seasonStyles.shortViewport}`;
    }

    return seasonStyles.christmas;
  };

  if (!season) {
    return '';
  }

  return `${seasonStyles.seasonalPage} ${getSeasonVariablesClassName(season)}`;
}
